import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApi from "../utils/useApi";

export default function useBranchKpis({
  branchId,
  startDate,
  endDate,
  revenueMode = "presencial",
  enabled = true,
}) {
  const { getBranchKpis } = useApi();
  const { user } = useAuth();

  const { data, isLoading, isError } = useQuery({
    queryKey: [
      "branch-kpis",
      user?.user_id ?? null,
      branchId,
      startDate,
      endDate,
      revenueMode,
    ],
    queryFn: () =>
      getBranchKpis({
        branch_id: branchId,
        start_date: startDate,
        end_date: endDate,
        revenue_mode: revenueMode,
      }),
    enabled: Boolean(enabled && branchId && startDate && endDate),
  });

  return { data: data?.data, isLoading, isError };
}
